import * as constants from "./constants";

export default function (state, action) {
    if (!state || action.type == constants.ORDER_CLEAR_STORE) {
        state = {
            orderDetail: {},
            orderPrimeCost: {},
            orderEdit: {},
            orderList: [],
            orderListSummury: [],
            orderListMediumSummury: [],
            orderPayment: [],
            orderHistory: [],
            orderCustomerInfo: undefined,
            isCustomerInfoLoading: false,
            invoce: {},
            isInvoceLoading: false,
            isSaved: false,
            isLoaded: false,
            isLoading: false,
            id: null,
            isChangedStatus: false,
            isChangingStatus: false,
        };
    }

    switch (action.type) {
        case constants.ORDER_NEW_SAVE_START:
            return { ...state, ...{ isLoading: true, error: undefined } };
        case constants.ORDER_NEW_SAVE_SUCCESS:
            return {
                ...state,
                ...{
                    isSaved: true,
                    id: action.data.id,
                    internalId: action.data.internalId,
                    isLoading: false,
                    amount: action.data.amount,
                },
            };
        case constants.ORDER_NEW_SAVE_FAIL:
            return {
                ...state,
                ...{ isLoading: false, isSaved: false, error: action.error },
            };

        case constants.ORDER_EDIT_SAVE_START:
            return { ...state, ...{ isLoading: true, error: undefined } };
        case constants.ORDER_EDIT_SAVE_SUCCESS:
            return {
                ...state,
                ...{
                    isSaved: true,
                    id: action.data.id,
                    internalId: action.data.internalId,
                    companyId: action.data.companyId,
                    isLoading: false,
                    amount: action.data.amount,
                },
            };
        case constants.ORDER_EDIT_SAVE_FAIL:
            return {
                ...state,
                ...{ isLoading: false, isSaved: false, error: action.error },
            };

        case constants.ORDER_LIST_LOAD_START:
            return {
                ...state,
                ...{ orderList: [], isLoading: true, error: undefined },
            };
        case constants.ORDER_LIST_LOAD_SUCCESS:
            return {
                ...state,
                ...{
                    orderList: Array.from(action.data, (x) => {
                        return { ...x, date: new Date(x.date) };
                    }).sort(compare),
                    isLoading: false,
                },
            };
        case constants.ORDER_LIST_LOAD_FAIL:
            return { ...state, ...{ isLoading: false, error: action.error } };

        case constants.ORDER_LIST_SUMMURY_LOAD_START:
            return {
                ...state,
                ...{ orderListSummury: [], isLoading: true, error: undefined },
            };
        case constants.ORDER_LIST_SUMMURY_LOAD_SUCCESS:
            return {
                ...state,
                ...{
                    orderListSummury: Array.from(action.data, (x) => {
                        return { ...x, date: new Date(x.date) };
                    }).sort(compare),
                    isLoading: false,
                },
            };
        case constants.ORDER_LIST_SUMMURY_LOAD_FAIL:
            return { ...state, ...{ isLoading: false, error: action.error } };

        case constants.ORDER_LIST_MEDIUM_SUMMURY_LOAD_START:
            return {
                ...state,
                ...{ orderListMediumSummury: [], isLoading: true, error: undefined },
            };
        case constants.ORDER_LIST_MEDIUM_SUMMURY_LOAD_SUCCESS:
            return {
                ...state,
                ...{
                    orderListMediumSummury: Array.from(action.data, (x) => {
                        return { ...x, date: new Date(x.date) };
                    }).sort(compare),
                    isLoading: false,
                },
            };
        case constants.ORDER_LIST_MEDIUM_SUMMURY_LOAD_FAIL:
            return { ...state, ...{ isLoading: false, error: action.error } };

        case constants.ORDER_EDIT_LOAD_START:
            return {
                ...state,
                ...{ orderEdit: {}, isLoading: true, error: undefined },
            };
        case constants.ORDER_EDIT_LOAD_SUCCESS:
            return {
                ...state,
                ...{
                    orderEdit: { ...action.data, date: new Date(action.data.date) },
                    isLoading: false,
                },
            };
        case constants.ORDER_EDIT_LOAD_FAIL:
            return { ...state, ...{ isLoading: false, error: action.error } };

        case constants.ORDER_DETAIL_LOAD_START:
            return {
                ...state,
                ...{
                    orderDetail: {},
                    isLoading: true,
                    isLoaded: false,
                    error: undefined,
                },
            };
        case constants.ORDER_DETAIL_LOAD_SUCCESS:
            return {
                ...state,
                ...{
                    orderDetail: { ...action.data, date: new Date(action.data.date) },
                    isLoading: false,
                    isLoaded: true,
                },
            };
        case constants.ORDER_DETAIL_LOAD_FAIL:
            return { ...state, ...{ isLoading: false, error: action.error } };

        case constants.ITEM_HISTORY_LOAD_START:
            return {
                ...state,
                ...{
                    orderHistory: [],
                },
            };
        case constants.ITEM_HISTORY_LOAD_SUCCESS:
            return {
                ...state,
                ...{
                    orderHistory: Array.from(action.data, x => { return { ...x, date: new Date(x.date) } }).sort(compareAsc),
                },
            };
        case constants.ITEM_HISTORY_LOAD_FAIL:
            return { ...state, ...{ error: action.error } };

        case constants.ORDER_CHANGE_STATUS_START:
            return {
                ...state,
                ...{
                    isChangedStatus: false,
                    isChangingStatus: true,
                    isChangedStatusError: undefined,
                },
            };
        case constants.ORDER_CHANGE_STATUS_SUCCESS:
            return {
                ...state,
                ...{
                    isChangedStatus: true,
                    isChangingStatus: false,
                },
            };
        case constants.ORDER_CHANGE_STATUS_FAIL:
            return {
                ...state,
                ...{
                    isChangedStatus: false,
                    isChangingStatus: false,
                    isChangedStatusError: action.error,
                },
            };

        case constants.ORDER_CUSTOMER_INFO_LOAD_START:
            return {
                ...state,
                ...{
                    orderCustomerInfo: undefined,
                    isCustomerInfoLoading: true,
                    isorderCustomerInfo: undefined,
                },
            };
        case constants.ORDER_CUSTOMER_INFO_LOAD_SUCCESS:
            return {
                ...state,
                ...{
                    orderCustomerInfo: action.data,
                    isCustomerInfoLoading: false,
                },
            };
        case constants.ORDER_CUSTOMER_INFO_LOAD_FAIL:
            return {
                ...state,
                ...{
                    orderCustomerInfo: undefined,
                    isCustomerInfoLoading: false,
                    isorderCustomerInfo: action.error,
                },
            };

        case constants.ORDER_PAYMENT_LOAD_START:
            return {
                ...state,
                ...{ orderPayment: [], isOrderPaymentIsLoading: true },
            };
        case constants.ORDER_PAYMENT_LOAD_SUCCESS:
            return {
                ...state,
                ...{
                    orderPayment: Array.from(action.data, (x) => {
                        return { ...x, date: new Date(x.date) };
                    }).sort((a, b) => a.order - b.order),
                    isOrderPaymentIsLoading: false,
                },
            };
        case constants.ORDER_PAYMENT_LOAD_FAIL:
            return {
                ...state,
                ...{
                    isOrderPaymentIsLoading: false,
                    isorderCustomerInfo: action.error,
                },
            };

        case constants.itemPrimeCostLoadStart:
            return {
                ...state,
                ...{
                    orderPrimeCost: {},
                },
            };
        case constants.itemPrimeCostLoadSuccess:
            return {
                ...state,
                ...{
                    orderPrimeCost: action.data,
                },
            };
        case constants.itemPrimeCostLoadFail:
            return {
                ...state,
            };

        case constants.itemSaveInvoiceStart:
            return {
                ...state,
                ...{ invoce: {}, isInvoceLoading: true },
            };
        case constants.itemSaveInvoiceSuccess:
            return {
                ...state,
                ...{
                    invoce: action.data,
                    isInvoceLoading: false,
                },
            };
        case constants.itemSaveInvoiceFail:
            return {
                ...state,
                ...{
                    invoce: actionData,
                    isInvoceLoading: false,
                },
            };

        case constants.itemCheckInvoiceStart:
            return {
                ...state,
                ...{ isLoading: true },
            };
        case constants.itemCheckInvoiceSuccess:
        case constants.itemCheckInvoiceFail:
            return {
                ...state,
                ...{
                    isLoading: false,
                    isChangedStatus: true,
                },
            };

        default:
            return state;
    }
}

function compare(a, b) {
    const bandA = a.date;
    const bandB = b.date;

    let comparison = 0;
    if (bandA > bandB) {
        comparison = 1;
    } else if (bandA < bandB) {
        comparison = -1;
    }
    return -comparison;
}

function compareAsc(a, b) {
    const bandA = a.date;
    const bandB = b.date;

    let comparison = 0;
    if (bandA > bandB) {
        comparison = 1;
    } else if (bandA < bandB) {
        comparison = -1;
    }
    return comparison;
}
